import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useActiveClientContext } from 'store/active-client';
import MainLayout from 'components/main-layout/MainLayout';
import LayoutContent from 'components/main-layout/LayoutContent';
import NotAuthorizedScreen from 'routes/not-authorized';
import { getSubdomain } from 'utils/helpers/routing';
import { getUserInfo } from 'utils/auth';

interface IProps {
  isLoading?: boolean;
  error?: unknown;
  children: React.ReactNode;
}

const HourlyAbsences: FC<IProps> = ({ isLoading, error, children }) => {
  const { t } = useTranslation();
  const isHourlyAbsencesActive = getUserInfo().featureHourlyAbsences;
  const { client } = useActiveClientContext();

  const isOperator = getSubdomain() === 'operators';

  if (isHourlyAbsencesActive || (isOperator && client?.is_hourly_absences)) {
    return (
      <MainLayout title={t('hourlyAbsences.title')}>
        <LayoutContent
          isLoading={isLoading}
          error={error}
        >
          {children}
        </LayoutContent>
      </MainLayout>
    );
  }
  return <NotAuthorizedScreen />;
};

export default HourlyAbsences;
